import React from 'react';
import { useTranslation } from 'react-i18next';

import imgSupportive1 from 'images/img-bene-supportive-1.png';
import imgSupportive2 from 'images/img-bene-supportive-2.png';
import imgSupportive3 from 'images/img-bene-supportive-3.png';

const features = [
  {
    id: 1,
    title: 'auth:bene_access_feature_section_label_1',
    description: 'auth:bene_access_feature_section_description_1',
    img: imgSupportive1,
  },
  {
    id: 2,
    title: 'auth:bene_access_feature_section_label_2',
    description: 'auth:bene_access_feature_section_description_2',
    img: imgSupportive2,
  },
  {
    id: 3,
    title: 'auth:bene_access_feature_section_label_3',
    description: 'auth:bene_access_feature_section_description_3',
    img: imgSupportive3,
  },
];

const BeneSupportiveInfo = () => {
  const { t } = useTranslation(['auth']);

  return (
    <div className="t-flex t-flex-col t-items-center lg:t-flex-row lg:t-justify-between">
      {features.map((feature) => (
        <div
          className={`t-flex t-flex-col t-items-center t-max-w-80 md:t-max-w-64 t-mt-7 lg:t-mt-0 ${
            feature.id !== 1 ? 'xl:t-ml-24 lg:t-ml-14' : ''
          }`}
          key={feature.id}
        >
          <img
            src={feature.img}
            className="t-max-h-20"
            alt={t(feature.title)}
          />
          <h2 className="typo-beta t-mt-3">{t(feature.title)}</h2>
          <p className="typo-epsilon t-text-beta-500 t-text-center t-mt-2.5">
            {t(feature.description)}
          </p>
        </div>
      ))}
    </div>
  );
};

export default BeneSupportiveInfo;
